import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const client = {
  VITE_PUBLIC_APPWRITE_ENDPOINT: z
    .string()
    .default("https://stage.cloud.appwrite.io/v1"),
  VITE_PUBLIC_AI_SERVICE_ENDPOINT: z.string().default("http://localhost:8889"),
  VITE_PUBLIC_APPWRITE_SITES_BASE_URL: z
    .string()
    .default("https://stage.appwrite.network"),
  VITE_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
  VITE_PUBLIC_POSTHOG_HOST: z
    .string()
    .optional()
    .default("https://us.i.posthog.com"),
  VITE_PUBLIC_ENVIRONMENT: z.string().default("local"),
  VITE_PUBLIC_REALTIME_URI: z.string().default("ws://localhost:8891/ws"),
};

export const env = createEnv({
  clientPrefix: "VITE_PUBLIC_",
  client,
  runtimeEnv: import.meta.env,
});
